import React from 'react';
import './Header.css'
import resumeData  from '../../Utils/resumeData'
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    Nav,
    Navbar,
    NavDropdown,
    Form,
    FormControl,
    Button
} from 'react-bootstrap'
import CustomButton from '../Button/Button'
import {NavLink, Link, withRouter } from 'react-router-dom'
// >>>>>>>>>>>>>>>>>>>>>Icon
import HomeIcon from '@material-ui/icons/Home';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
// >>>>>>>>> work 


const Header = (props) => {

const pathName = props?.location?.pathname;

    return (
        <div>
<Navbar  expand="lg" sticky="top" className="header">
    {/* Home Link */}
  <Nav.Link as={NavLink} to="/" className={"p_0_m_0"}>
      <Navbar.Brand className="header_home">
        <HomeIcon />
      </Navbar.Brand>
  </Nav.Link>
    <Navbar.Toggle />

    <Navbar.Collapse>
        <Nav className="header_left">

        <Nav.Link as={NavLink} to="/" className={pathName == '/' ? 'header_link_active' : 'header_link' } > Resume </Nav.Link>
             {/* Portfolio */}

            {/* About Link */}
            <Nav.Link as={NavLink} to="/about" 
            className={pathName == '/about' ? 'header_link_active' : 'header_link' } >About</Nav.Link>
           
               
        

             <Nav.Link as={NavLink} to="/portfolio" 
            className={pathName == '/portfolio' ? 'header_link_active' : 'header_link' } > Portfolio </Nav.Link>
            {/* Contact Link */}
            <Nav.Link as={NavLink} to="/contact" 
            className={pathName == '/contact' ? 'header_link_active' : 'header_link' } >Contact</Nav.Link>

        </Nav>
        <div className="header_right">
            {
                 Object.keys(resumeData.socile).map(key=> (
                    <a href={resumeData.socile[key].link} target="_blank" >{resumeData.socile[key].icon} </a>
                ))
            }        
            <CustomButton text="Hire me" icon={<WhatsAppIcon />} />    
        </div>
    </Navbar.Collapse>
</Navbar>
        </div>
    );
};

export default withRouter(Header);